const numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

const phoneHref = (tel: string | null): string => {
  if (!tel) {
    return '';
  }

  const parseTel = tel
    .split('')
    .filter((item) => numbers.includes(item))
    .join('');

  return `tel:+${parseTel}`;
};

export default phoneHref;
